import * as Reducer from './slice';

interface IAppState {
  // this feature state
  app: Reducer.IAppState;
}

const getAppState = (state: IAppState) => state.app;

export const isAppLoading = (state: IAppState) => getAppState(state).loading;
